import api from "@/api/api";

export default {
  index(params = {}) {
    return api.get("main/app-notifications", { params });
  },
  markRead(id) {
    return api.patch(`main/app-notifications/${id}/read`);
  },
  markAllRead(params = {}) {
    return api.post("main/app-notifications/read-all", params);
  },
  clear(id) {
    return api.delete(`main/app-notifications/${id}`);
  },
  clearAll(params = {}) {
    return api.post("main/app-notifications/clear-all", params);
  },
};
